export default __webpack_public_path__ + "static/media/free.76323274.svg";